"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Condition = void 0;
var format_error_1 = require("./format-error");
var condition_target_1 = require("./condition-target");
var observable_array_1 = require("./observable-array");
var Condition = /** @class */ (function () {
    /**
        * Creates a condition of a specific type associated with one or more entities in a model.
        * @param type The type of condition, which usually is an instance of a subclass like Error, Warning or Permission.
        * @param message The optional message to use for the condition, which will default to the condition type message if not specified.
        * @param target The root target entity the condition is associated with.
        * @param properties The set of property paths specifying which properties and entities the condition should be attached to.
        */
    function Condition(type, message, target, source, properties) {
        var _this = this;
        if (properties === void 0) { properties = []; }
        this.type = type;
        this._message = message || (type ? type.message : undefined);
        var targets = this.targets = observable_array_1.ObservableArray.create();
        this.source = source;
        // create targets if a root was specified
        if (target) {
            var _loop_1 = function (p) {
                var path = properties[p];
                var targetInfos = [];
                // build list of objects containing ConditionTarget information
                // we don't want to construct ConditionTargets as we're processing the path because we may not have gathered all targeted properties,
                // and the constructor triggers change on the entity meta's conditions list, which should be in a correct state before publishing the event
                path.each(target, function (entity, property) {
                    if (property !== path.lastProperty)
                        return;
                    // see if a target already exists for the current instance
                    var targetInfo = targetInfos.find(function (t) { return t.entity === entity; });
                    // create the condition target if it does not already exist
                    if (!targetInfo) {
                        targetInfo = { entity: entity, properties: [property] };
                        targetInfos.push(targetInfo);
                    }
                    // otherwise, just ensure it references the current step
                    else if (!targetInfo.properties.includes(property))
                        targetInfo.properties.push(property);
                });
                // construct the ConditionTargets here now that we've gathered all information
                targets.push.apply(targets, targetInfos.map(function (i) { return new condition_target_1.ConditionTarget(_this, i.entity, i.properties); }));
            };
            // process each property path to build up the condition sources
            for (var p = properties.length - 1; p >= 0; p--) {
                _loop_1(p);
            }
        }
        // raise events for the new condition
        if (type !== format_error_1.FormatError.ConditionType) {
            var conditionType = type;
            // raise events on condition targets
            for (var t = targets.length - 1; t >= 0; t--) {
                var conditionTarget = targets[t];
                // type events
                for (var objectType = conditionTarget.target.meta.type; objectType != null; objectType = objectType.baseType) {
                    // (objectType.conditionsChanged as Event<Type, ConditionTargetsChangedEventArgs>).publish(objectType, { conditionTarget: conditionTarget, add: true });
                }
            }
            // Add the condition to the corresponding condition type
            conditionType.conditions.push(this);
            // Add the condition to relevant condition type sets
            if (this.type.sets) {
                for (var s = this.type.sets.length - 1; s >= 0; s--) {
                    this.type.sets[s].conditions.push(this);
                }
            }
        }
    }
    Object.defineProperty(Condition.prototype, "message", {
        get: function () {
            if (typeof (this._message) === "string")
                return this._message;
            else
                return this._message();
        },
        set: function (val) {
            this._message = val;
        },
        enumerable: false,
        configurable: true
    });
    Condition.prototype.destroy = function () {
        /// <summary>Removes the condition targets from all target instances and raises condition change events.</summary>
        // raise events on condition type sets
        if (this.type.sets) {
            for (var s = this.type.sets.length - 1; s >= 0; s--) {
                var set = this.type.sets[s];
                var idx_1 = set.conditions.indexOf(this);
                if (idx_1 >= 0) {
                    set.conditions.splice(idx_1, 1);
                }
            }
        }
        // raise events on condition types
        var idx = this.type.conditions.indexOf(this);
        if (idx >= 0) {
            this.type.conditions.splice(idx, 1);
        }
        for (var t = this.targets.length - 1; t >= 0; t--) {
            var conditionTarget = this.targets[t];
            var objectMeta = conditionTarget.target.meta;
            objectMeta.clearCondition(conditionTarget.condition.type);
            // type events
            for (var objectType = conditionTarget.target.meta.type; objectType != null; objectType = objectType.baseType) {
                // (objectType.conditionsChanged as Event<Type, ConditionTargetsChangedEventArgs>).publish(objectType, { conditionTarget: conditionTarget, add: false, remove: true });
            }
        }
        // remove references to all condition targets
        this.targets.splice(0);
    };
    Condition.prototype.toString = function () {
        return this.message;
    };
    return Condition;
}());
exports.Condition = Condition;
